import { storage } from './localStorage.js';

export const tokenManager = {
  // Check if user is authenticated
  isAuthenticated: () => {
    return !!storage.getJWT();
  },
  
  // Get token for API requests
  getAuthToken: () => {
    return storage.getJWT();
  },
  
  // Get send OTP token
  getSendOtpToken: () => {
    return storage.getSendOtpJWT();
  },
  
  // Get verify OTP token
  getVerifyOtpToken: () => {
    return storage.getVerifyOtpJWT();
  },
  
  // Clear expired tokens (basic implementation)
  clearExpiredTokens: () => {
    // This is a basic implementation
    // In a real app, you'd decode JWT to check expiration
    const jwt = storage.getJWT();
    if (jwt) {
      try {
        const payload = JSON.parse(atob(jwt.split('.')[1]));
        if (payload.exp && Date.now() >= payload.exp * 1000) {
          storage.clearAll();
          return true; // Token was expired and cleared
        }
      } catch (error) {
        console.error('Error checking token expiration:', error);
        storage.clearAll();
        return true;
      }
    }
    return false;
  },
  
  // Logout user
  logout: () => {
    storage.clearAll();
  }
};